<template>
  <div>
    <font-awesome-icon
      id="font-awesome-icon-edit"
      icon="edit"
      size="sm"
      class="clickable float-right"
      v-if="showEditButton"
      @click="$emit('edit-button-clicked')"
      />
    <hr/>
  </div>
</template>

<script>
export default {
  props: {
    showEditButton: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="sass" scoped>
hr
  border-top: 2px solid !important
</style>
